import resources from './resources';

export const message = (key, params = {}) => ({ key, params });
export const isMessage = value => Boolean(value && typeof value.key === 'string');

// Compatibility boundary for application-owned labels and legacy validation results.
// Never use this for user-authored names, notes, lesson topics or other domain data.
const legacyKeys = new Map();
function collect(value, prefix) {
  Object.entries(value).forEach(([key, item]) => {
    const path = `${prefix}${key}`;
    if (typeof item === 'string' && !item.includes('{{')) legacyKeys.set(item, path);
    else if (item && typeof item === 'object') collect(item, `${path}.`);
  });
}
Object.values(resources).reverse().forEach(namespaces => {
  Object.entries(namespaces).forEach(([namespace, values]) => collect(values, `${namespace}:`));
});

export function localizeSystemText(value, t) {
  if (isMessage(value)) {
    const params = { ...value.params };
    if (value.key === 'common:requiredField') params.field = localizeSystemText(params.field, t);
    return t(value.key, params);
  }
  if (typeof value !== 'string' || !value) return value;
  const key = legacyKeys.get(value);
  if (key) return t(key);
  const requiredField = value.match(/^Pole (.+) jest wymagane\.$/);
  if (requiredField) return t('common:requiredField', { field: localizeSystemText(requiredField[1], t) });
  return value;
}
